import CartAddDeliveryAddress from '../components/CartAddDeliveryAddress'
import CartDeliveryDate from '../components/CartDeliveryDate'
import CartReservationVerifyAddress from '../components/CartReservationVerifyAddress'

import styles from './StandardDelivery.module.scss'

const StandardDelivery = () => (
  <>
    <CartAddDeliveryAddress />
    <hr className={styles.hr} />
    <CartDeliveryDate />
    <CartReservationVerifyAddress />
  </>
)

export default StandardDelivery
